import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/locale/nl';
import 'moment/locale/de';
import 'moment/locale/en-gb';

// Importing a moment locale file is not passive: moment.defineLocale sets it as
// the ACTIVE global locale. Several modules import 'moment/locale/nl' for their
// own use, so without this hook the app's date locale is whichever locale module
// the bundler happened to evaluate last — Dutch dates for English users.
//
// Applied once, high in the tree (TranslationProvider), so every un-localised
// moment().format() in the app follows the user's language.
const useMomentLocale = () => {
    const { currentLanguageCode, locales } = useSelector(state => state.appTranslations);

    useEffect(() => {
        // Build locale map dynamically from API locales
        const localeMap = {};
        locales?.forEach(locale => {
            // Map both full code (nl_NL) and short code (nl) to moment locale (nl)
            if (locale.short) {
                localeMap[locale.code] = locale.short;
                localeMap[locale.short] = locale.short;
            }
        });

        // 'en' is moment's built-in default and always available, so it is the
        // safe fallback when the language is unknown or the locales API has not
        // resolved yet.
        moment.locale(localeMap[currentLanguageCode] || 'en');
    }, [currentLanguageCode, locales]);

    return currentLanguageCode;
};

export default useMomentLocale;
